import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";
import type { FilterItemType } from "@shared/content-types/types";

import { mapDtoToArticles, type NewsListType } from "../model";
import { mapDtoToNewsPage } from "../model/mappers";
import { searchParams } from "./params";

type DataType = {
  list: NewsListType;
  filters: FilterItemType[];
};

export const getNewsPage = async () => {
  const newsPageData = strapiClient.single("news-page");
  const articles = strapiClient.collection("articles");

  const newsPage = await newsPageData.find({
    ...searchParams.page,
  });

  const list = await articles.find({
    ...searchParams.articles,
  });

  return rebuild({
    list: mapDtoToArticles(list),
    page: mapDtoToNewsPage(newsPage),
  }) as DataType;
};
